import React, { useState } from "react";
import ColumnModal from "../../components/modals/inventory/configure-coloumn-modal";
import FilterModal from "../../components/modals/inventory/filter-modal";
import { errorToast, successToast } from "../../components/notifications/toast";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Loader from "../../components/loaders/dot-loader";
import exportFromJSON from "export-from-json";
import SelectDropdown from "../../components/forms/selectDropdown";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { productSalesReportAction } from "../../redux/actions/reportAction";
import DateModal from "../../components/modals/date-modal";

const ProductSalesReport = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [selectedColumns, setSelectedColumns] = useState(allColumns.map((item) => item.value));
    const [filters, setFilters] = useState([{ field: "", operator: "", value: "" }]);
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isFilterModalOpen, setFilterModalOpen] = useState(false);
    const [isColumnModalOpen, setColumnModalOpen] = useState(false);
    const [selectedDateRange, setSelectedDateRange] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);

    const fileName = "productSalesReport"; // CSV
    const exportType = exportFromJSON.types.csv; // CSV

    const downloadCsvReport = () => {
        const filteredData = reportData.map((row) => {
            const newRow = {};
            selectedColumns.forEach((col) => {
                newRow[col] = row[col];
            });
            return newRow;
        });
        exportFromJSON({ data: filteredData, fileName, exportType });
    }

    const downloadAsPdf = (headers, tableRows) => {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.text(`ProductSales Report`, 105, 15, { align: "center" });
        doc.setFontSize(12);
        const tableHeaders = [headers];

        doc.autoTable({
            head: tableHeaders,
            body: tableRows,
            startY: 20,
            theme: "striped",
        });
        doc.save(`ProductSales_Report.pdf`);
    };


    const operators = [
        { label: "Equals", value: "equals" },
        { label: "Contains", value: "contains" },
        { label: "Greater Than", value: ">" },
        { label: "Less Than", value: "<" },
        { label: "Greater Than or Equal To", value: ">=" },
        { label: "Less Than or Equal To", value: "<=" },
    ];


    const handleGenerateReport = () => {
        setLoading(true);
        dispatch(productSalesReportAction({ filters, date_range: selectedDateRange, from_date: fromDate, to_date: toDate }, onSuccess, onError))
    };

    const onSuccess = (data) => {
        const transformedData = data.data.data.map((item) => ({
            code: item?.product?.code || "N/A",
            name: item?.product?.name || "N/A",
            uom: item?.product?.uom,
            quantity: item?.totalSoldQuantity,
            pts: item?.pts,
            ptr: item?.ptr,
            mrp: item?.mrp,
            totalSales: item?.totalSales,
            totalRevenue: item?.totalRevenue,
            totalTransactions: item?.totalTransactions,
            profit: item?.profit
        }));
        console.log(transformedData, "transformedData");
        successToast(data.data.message);
        setReportData(transformedData);
        setLoading(false)
    }

    const onError = (data) => {
        const errorMsg = data.data.message || "Unable to fetch try later";
        errorToast(errorMsg)
        setLoading(false)
    }


    return (
        <div className="flex items-center justify-center bg-gray-100" style={{ height: "95vh" }}>
            <div className="w-full mx-6 bg-white shadow-lg rounded-md flex flex-col" style={{ height: '95%' }}>
                {/* Header Section */}
                <div className="md:flex justify-between items-center p-4 border-b text-nowrap">
                    <div className="flex items-center gap-4">
                        <button
                            onClick={() => navigate(-1)}
                            className="text-blue-500 hover:text-blue-700"
                        >
                            &lt; Back
                        </button>

                        <h1 className="text-lg font-medium text-start text-primary">Product Sales Report</h1>
                    </div>
                    <div className="flex flex-col sm:flex-row gap-3">
                        <div className="flex gap-2 justify-end items-center px-3">
                            <span className="text-primary">Date Range</span>
                            <div className="w-24">
                                <SelectDropdown
                                    options={[
                                        { label: 'All', value: '' },
                                        { label: 'Today', value: 'today' },
                                        { label: 'This Week', value: 'this_week' },
                                        { label: 'This Month', value: 'this_month' },
                                        { label: 'Custom', value: 'custom' }
                                    ]}
                                    onChange={(name, value) => {
                                        setSelectedDateRange(value);
                                        if (value === "custom") {
                                            setIsModalOpen(true)
                                        } else {
                                            setFromDate('');
                                            setToDate('')
                                        }
                                    }}
                                    value={selectedDateRange}
                                    placeholder="Select"
                                    name="date_range"
                                />
                            </div>
                        </div>
                        {/* <button
                            onClick={() => setFilterModalOpen(true)}
                            className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                        >
                            Configure Filters
                        </button> */}
                        <button
                            onClick={() => setColumnModalOpen(true)}
                            className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                        >
                            Select Columns
                        </button>
                        <button
                            onClick={handleGenerateReport}
                            className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600"
                        >
                            {loading ? "Generating..." : "Generate Report"}
                        </button>
                        {reportData.length > 0 &&
                            <div className="flex gap-2 justify-end items-center px-3">
                                <span className="text-primary">Export</span>
                                <div>
                                    <SelectDropdown
                                        options={[{ label: 'CSV', value: 'csv' }, { label: 'Pdf', value: 'pdf' }]}
                                        onChange={(name, value) => {
                                            if (value === "csv") {
                                                downloadCsvReport()
                                            }
                                            if (value === "pdf") {
                                                const tableHeaders = selectedColumns.map((col) =>
                                                    allColumns.find((column) => column.value === col)?.label
                                                );
                                                const updatedData = reportData.map((row) =>
                                                    selectedColumns.map((col) => row[col])
                                                );
                                                downloadAsPdf(tableHeaders, updatedData)
                                            }
                                        }}
                                        placeholder="Select"
                                        name="download"
                                        className="input-field"
                                    />
                                </div>
                            </div>
                        }
                    </div>

                </div>
                <div className={`relative overflow-auto h-full pt-3`}>

                    <div className="overflow-auto mx-3 border border-gray-300 rounded-md h-full" style={{ maxHeight: '48rem' }}>
                        {reportData.length > 0 ? (
                            <table className="w-full border-collapse border rounded-md">
                                <thead>
                                    <tr className="bg-gray-100 sticky top-0">
                                        <th className="p-2 border font-medium">#</th>
                                        {selectedColumns.map((col) => (
                                            <th key={col} className="p-2 border font-medium">
                                                {allColumns.find((column) => column.value === col)?.label}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {reportData.map((row, index) => (
                                        <tr key={index}>
                                            <td className="p-2 border">{index + 1}</td>
                                            {selectedColumns.map((col) => (
                                                <td key={col} className="p-2 border">
                                                    {row[col]}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <div className=" flex justify-center items-center " style={{ height: '38rem' }}>
                                {loading ? <Loader /> :
                                    <p className="flex justify-center items-center">No data available</p>
                                }
                            </div>
                        )}
                    </div>
                </div>

                {/* Filter Modal */}
                {isFilterModalOpen && (
                    <FilterModal
                        filters={filters}
                        setFilters={setFilters}
                        operators={operators}
                        allColumns={allColumns}
                        onClose={() => setFilterModalOpen(false)}
                    />
                )}

                {/* Column Modal */}
                {isColumnModalOpen && (
                    <ColumnModal
                        selectedColumns={selectedColumns}
                        setSelectedColumns={setSelectedColumns}
                        allColumns={allColumns}
                        onClose={() => setColumnModalOpen(false)}
                    />
                )}
                <DateModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    fromDate={fromDate}
                    setFromDate={setFromDate}
                    toDate={toDate}
                    setToDate={setToDate}
                />
            </div>
        </div>
    );
};

const allColumns = [
    { value: "code", label: "Product Code" },
    { value: "name", label: "Product Name" },
    { value: "uom", label: "UOM" },
    { value: "quantity", label: "Sold Quantity" },
    { value: "pts", label: "PTS" },
    { value: "ptr", label: "PTR" },
    { value: "mrp", label: "MRP" },
    { value: "totalSales", label: "Total Sales" },
    { value: "totalRevenue", label: "Total Revenue" },
    { value: "totalTransactions", label: "Transactions" },
    { value: "profit", label: "Profit" }
];

export default ProductSalesReport;

